module.exports = __webpack_public_path__ + "static/media/fia.ff8d15d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/partners/fia.svg
// module id = 1698
// module chunks = 1